module.exports = __webpack_public_path__ + "img/ai.b3108c2f.png";